<!--
 * @Author: zhaoliang
 * @Date: 2025-07-23 11:36:22
 * @LastEditTime: 2025-07-29 19:08:22
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/Home/Components/TopNotice/index.vue
 *
-->
<template>
  <div class="top-notice-wrapper">
    <div class="top-notice-box">
      <div class="top-notice-icon">
        <img src="@/assets/images/icon-warning-triangle.svg" alt="warning" />
      </div>
      <div class="top-notice-content">
        <div class="top-notice-title">
          <span>{{ $t('idc-migration-title') }}</span>
        </div>
        <div class="top-notice-desc">
          <span>{{ $t('idc-migration-desc') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'TopNotice',
  };
</script>
<style lang="scss" scoped>
  .top-notice-wrapper {
    height: 84px;
    background-color: #fff8e0;
    padding: 16px 300px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;

    .top-notice-box {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 8px;

      .top-notice-icon {
        width: 20px;
        flex-shrink: 0;
        display: flex;
        align-items: flex-start;
        height: 100%;

        img {
          width: 100%;
          height: auto;
          display: block;
        }
      }

      .top-notice-content {
        flex: 1;

        .top-notice-title {
          font-size: 16px;
          line-height: 1.5;
          color: #2f3438;
          font-weight: 600;
          margin-bottom: 4px;
        }

        .top-notice-desc {
          font-size: 16px;
          line-height: 1.5;
          color: #2f3438;
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .top-notice-wrapper {
      height: 108px;
      background-color: #fff8e0;
      padding: 12px 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;

      .top-notice-box {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 8px;

        .top-notice-icon {
          width: 16px;
          flex-shrink: 0;
          display: flex;
          align-items: flex-start;
          height: 100%;

          img {
            width: 100%;
            height: auto;
            display: block;
          }
        }

        .top-notice-content {
          flex: 1;

          .top-notice-title {
            font-size: 12px;
            line-height: 1.5;
            color: #2f3438;
            font-weight: 600;
            margin-bottom: 4px;
          }

          .top-notice-desc {
            font-size: 12px;
            line-height: 1.5;
            color: #2f3438;
          }
        }
      }
    }
  }
</style>
